import { createApp } from 'vue'
import App from "./App";
import {router} from "./router";
import { setLanguageParameter } from "./router/router.extensions";
import {store} from "./store";
import {i18n} from "./locales/i18n";
import { startMain } from "@/services/scripts/main";
import { registerImageMapPro } from "@/services/scripts/imageMapPro.min";
import "./registerServiceWorker";
import SchemaSyncHandler from "./services/caching/schemasync";
import { forceReinitiliazationIfRequested } from "./services/offlineModeInitiliazer";
import { getWindow } from "./services/windowAdapter";
import "bootstrap";
import $ from "jquery";

import {
  initializeAnalytics
} from "@/services/analytics";
import Toast, { POSITION } from "vue-toastification";
import "vue-toastification/dist/index.css";

const window = getWindow();

window.$ = $;
window.jQuery = $;

if (window.location.search) {
  forceReinitiliazationIfRequested(window.location.search);
  window.location.search = "";
}



const options = {
  position: POSITION.TOP_CENTER,
  timeout: false,
  closeOnClick: false,
  closeButton: false
};


require("@fancyapps/fancybox");

setLanguageParameter(router);
startMain();
registerImageMapPro();

SchemaSyncHandler.sync();
initializeAnalytics();


const app = createApp(App);
app.use(store);
app.use(router);
app.use(i18n);
app.use(Toast, options)
app.mount("#app");


